const sr_Cyrl = {
  auth: {
    login: 'Пријава',
    loggingIn: 'Пријављивање...',
    loginWithNetlifyIdentity: 'Пријавите се преко Netlify Identity',
    loginWithAzure: 'Пријавите се преко Azure',
    loginWithBitbucket: 'Пријавите се преко Bitbucket',
    loginWithGitHub: 'Пријавите се преко GitHub',
    loginWithGitLab: 'Пријавите се преко GitLab',
    loginWithGitea: 'Пријавите се преко Gitea',
    errors: {
      email: 'Унесите своју е-пошту.',
      password: 'Молимо унесите лозинку.',
      identitySettings: 'Није могуће приступити подешавањима идентитета. Када користите git-gateway backend, обавезно омогућите Identity service и Git Gateway.'
    }
  },
  app: {
    header: {
      content: 'Садржај',
      workflow: 'Ток рада',
      media: 'Медији',
      quickAdd: 'Брзо додавање'
    },
    app: {
      errorHeader: 'Грешка при учитавању CMS конфигурације',
      configErrors: 'Грешка у конфигурацији',
      checkConfigYml: 'Проверите вашу config.yml датотеку.',
      loadingConfig: 'Учитавање конфигурације...',
      waitingBackend: 'Чекање на backend...'
    },
    notFoundPage: {
      header: 'Страница није пронађена'
    }
  },
  collection: {
    sidebar: {
      collections: 'Збирке',
      allCollections: 'Све збирке',
      searchAll: 'Претражи све',
      searchIn: 'Претражи у'
    },
    collectionTop: {
      sortBy: 'Сортирај по',
      viewAs: 'Погледај као',
      viewAsList: 'Приказ као листа',
      viewAsGrid: 'Приказ као мрежа',
      newButton: '＋ %{collectionLabel}',
      newButtonAriaLabel: 'Креирај унос врсте %{collectionLabel}',
      ascending: 'Растуће',
      descending: 'Опадајуће',
      searchResults: 'Резултати претраге за "%{searchTerm}"',
      searchResultsInCollection: 'Резултати претраге за "%{searchTerm}" у %{collection}',
      filterBy: 'Филтрирај по',
      groupBy: 'Групиши по'
    },
    entries: {
      loadingEntries: 'Учитавање уноса...',
      cachingEntries: 'Кеширање уноса...',
      longerLoading: 'Ово може потрајати неколико минута',
      noEntries: 'Нема уноса'
    },
    groups: {
      other: 'Остало',
      negateLabel: 'Није %{label}'
    },
    defaultFields: {
      author: {
        label: 'Аутор'
      },
      updatedOn: {
        label: 'Ажурирано'
      }
    }
  },
  editor: {
    editorControl: {
      field: {
        optional: 'опционо',
        widgetLabel: '%{widgetLabel} поље'
      }
    },
    editorControlPane: {
      widget: {
        required: '%{fieldLabel} је обавезно.',
        regexPattern: '%{fieldLabel} се не подудара са узорком: %{pattern}.',
        processing: '%{fieldLabel} се обрађује.',
        range: '%{fieldLabel} мора бити између %{minValue} и %{maxValue}.',
        min: '%{fieldLabel} мора бити најмање %{minValue}.',
        max: '%{fieldLabel} мора бити %{maxValue} или мање.',
        rangeCount: '%{fieldLabel} мора имати између %{minCount} и %{maxCount} ставки.',
        rangeCountExact: '%{fieldLabel} мора имати тачно %{count} ставки.',
        rangeMin: '%{fieldLabel} мора имати најмање %{minCount} ставку/е.',
        rangeMax: '%{fieldLabel} мора имати %{maxCount} или мање ставки.',
        invalidPath: `'%{path}' није валидна путања`,
        pathExists: `Путања '%{path}' већ постоји`
      },
      i18n: {
        writingInLocale: 'Писање на %{locale}',
        copyFromLocale: 'Попуни из другог језика',
        copyFromLocaleConfirm: 'Да ли желите да попуните податке из %{locale} локала?\nСав постојећи садржај ће бити преписан.'
      }
    },
    editor: {
      onLeavePage: 'Да ли сте сигурни да желите да напустите ову страницу?',
      onUpdatingWithUnsavedChanges: 'Имате несачуване измене, молимо сачувајте пре ажурирања статуса.',
      onPublishingNotReady: 'Молимо ажурирајте статус на „Спремно" пре објављивања.',
      onPublishingWithUnsavedChanges: 'Имате несачуване измене, молимо сачувајте пре објављивања.',
      onPublishing: 'Да ли сте сигурни да желите да објавите овај унос?',
      onUnpublishing: 'Да ли сте сигурни да желите да уклоните овај унос из објава?',
      onDeleteWithUnsavedChanges: 'Да ли сте сигурни да желите да избришете овај објављени унос, као и несачуване измене из тренутне сесије?',
      onDeletePublishedEntry: 'Да ли сте сигурни да желите да избришете овај објављени унос?',
      onDeleteUnpublishedChangesWithUnsavedChanges: 'Ово ће избрисати све необјављене измене на овом уносу, као и несачуване измене из тренутне сесије. Да ли и даље желите да избришете?',
      onDeleteUnpublishedChanges: 'Све необјављене измене на овом уносу ће бити избрисане. Да ли и даље желите да избришете?',
      loadingEntry: 'Учитавање уноса...',
      confirmLoadBackup: 'Пронађена је локална резервна копија за овај унос, да ли желите да је користите?'
    },
    editorInterface: {
      toggleI18n: 'Укључи/искључи i18n',
      togglePreview: 'Укључи/искључи преглед',
      toggleScrollSync: 'Синхронизација скроловања'
    },
    editorToolbar: {
      publishing: 'Објављивање...',
      publish: 'Објави',
      published: 'Објављено',
      unpublish: 'Уклони из објава',
      duplicate: 'Дупликат',
      unpublishing: 'Уклањање из објава...',
      publishAndCreateNew: 'Објави и креирај нови',
      publishAndDuplicate: 'Објави и дуплирај',
      deleteUnpublishedChanges: 'Избриши необјављене измене',
      deleteUnpublishedEntry: 'Избриши необјављени унос',
      deletePublishedEntry: 'Избриши објављени унос',
      deleteEntry: 'Избриши унос',
      saving: 'Чување...',
      save: 'Сачувај',
      statusInfoTooltipDraft: 'Статус уноса је постављен на нацрт. Да бисте га финализовали и послали на преглед, поставите статус на „На прегледу"',
      statusInfoTooltipInReview: 'Унос је на прегледу, нису потребне даље радње. Међутим, и даље можете да направите додатне измене dok је на прегледу.',
      deleting: 'Брисање...',
      updating: 'Ажурирање...',
      status: 'Статус: %{status}',
      backCollection: 'Писање у збирци %{collectionLabel}',
      unsavedChanges: 'Несачуване измене',
      changesSaved: 'Измене сачуване',
      draft: 'Нацрт',
      inReview: 'На прегледу',
      ready: 'Спремно',
      publishNow: 'Објави одмах',
      deployPreviewPendingButtonLabel: 'Провери за преглед',
      deployPreviewButtonLabel: 'Погледај преглед',
      deployButtonLabel: 'Погледај уживо'
    },
    editorWidgets: {
      markdown: {
        bold: 'Подебљано',
        italic: 'Курзив',
        strikethrough: 'Прецртано',
        code: 'Код',
        link: 'Веза',
        linkPrompt: 'Унесите URL везе',
        headings: 'Наслови',
        quote: 'Цитат',
        bulletedList: 'Набројана листа',
        numberedList: 'Нумерисана листа',
        addComponent: 'Додај компоненту',
        richText: 'Богати текст',
        markdown: 'Markdown',
        toggleMode: {
          rich: 'Пребаци на режим богатог текста',
          markdown: 'Пребаци на Markdown режим'
        }
      },
      image: {
        choose: 'Одабери слику',
        chooseMultiple: 'Одабери слике',
        chooseUrl: 'Унеси из URL-а',
        replaceUrl: 'Замени URL-ом',
        promptUrl: 'Унесите URL слике',
        chooseDifferent: 'Одабери другу слику',
        addMore: 'Додај још слика',
        remove: 'Уклони слику',
        removeAll: 'Уклони све слике'
      },
      file: {
        choose: 'Одабери датотеку',
        chooseUrl: 'Унеси из URL-а',
        chooseMultiple: 'Одабери датотеке',
        replaceUrl: 'Замени URL-ом',
        promptUrl: 'Унесите URL датотеке',
        chooseDifferent: 'Одабери другу датотеку',
        addMore: 'Додај још датотека',
        remove: 'Уклони датотеку',
        removeAll: 'Уклони све датотеке'
      },
      unknownControl: {
        noControl: "Контрола није пронађена за виџет '%{widget}'."
      },
      unknownPreview: {
        noPreview: "Приказ није пронађен за виџет '%{widget}'."
      },
      headingOptions: {
        headingOne: 'Наслов 1',
        headingTwo: 'Наслов 2',
        headingThree: 'Наслов 3',
        headingFour: 'Наслов 4',
        headingFive: 'Наслов 5',
        headingSix: 'Наслов 6'
      },
      datetime: {
        now: 'Сада',
        clear: 'Обриши',
        setToNow: 'Постави %{fieldLabel} на сада'
      },
      list: {
        add: 'Додај %{item}',
        addType: 'Додај %{item}'
      },
      object: {
        expand: 'Прошири',
        collapse: 'Сажми'
      }
    }
  },
  mediaLibrary: {
    mediaLibraryCard: {
      draft: 'Нацрт',
      copy: 'Копирај',
      copyUrl: 'Копирај URL',
      copyPath: 'Копирај путању',
      copyName: 'Копирај назив',
      copied: 'Копирано'
    },
    mediaLibrary: {
      onDelete: 'Да ли сте сигурни да желите да избришете одабране медијске датотеке?',
      fileTooLarge: 'Датотека је превелика.\nКонфигурисано да не дозвољава датотеке веће од %{size} kB.'
    },
    mediaLibraryModal: {
      loading: 'Учитавање...',
      close: 'Затвори',
      noResults: 'Нема резултата.',
      noAssetsFound: 'Медијска средства нису пронађена.',
      noImagesFound: 'Слике нису пронађене.',
      private: 'Приватно ',
      images: 'Слике',
      mediaAssets: 'Медијска средства',
      search: 'Претражи...',
      uploading: 'Учитавање...',
      upload: 'Учитај',
      download: 'Преузми',
      deleting: 'Брисање...',
      deleteSelected: 'Избриши означено',
      chooseSelected: 'Одабери означено'
    }
  },
  ui: {
    default: {
      goBackToSite: 'Назад на сајт'
    },
    errorBoundary: {
      title: 'Грешка',
      details: 'Дошло је до грешке - молимо ',
      reportIt: 'отворите проблем (issue) на GitHub-у.',
      detailsHeading: 'Детаљи',
      privacyWarning: 'Отварање проблема (issue) га попуњава поруком о грешци и подацима за отклањање грешака.\nМолимо проверите да ли су информације тачне и уклоните осетљиве податке ако постоје.',
      recoveredEntry: {
        heading: 'Обновљен документ',
        warning: 'Молимо копирајте/налепите ово негде пре одласка!',
        copyButtonLabel: 'Копирај у међуспремник'
      }
    },
    settingsDropdown: {
      logOut: 'Одјава',
      account: 'Опције налога'
    },
    toast: {
      onFailToLoadEntries: 'Неуспело учитавање уноса: %{details}',
      onFailToLoadDeployPreview: 'Неуспело учитавање прегледа: %{details}',
      onFailToPersist: 'Неуспело чување уноса: %{details}',
      onFailToDelete: 'Неуспело брисање уноса: %{details}',
      onFailToUpdateStatus: 'Неуспело ажурирање статуса: %{details}',
      missingRequiredField: 'Упс, прескочили сте обавезно поље. Молимо попуните пре чувања.',
      entrySaved: 'Унос сачуван',
      entryPublished: 'Унос објављен',
      entryUnpublished: 'Унос уклоњен из објава',
      onFailToPublishEntry: 'Неуспело објављивање уноса: %{details}',
      onFailToUnpublishEntry: 'Неуспело уклањање уноса из објава: %{details}',
      entryUpdated: 'Статус уноса ажуриран',
      onDeleteUnpublishedChanges: 'Необјављене измене избрисане',
      onFailToAuth: '%{details}',
      onLoggedOut: 'Одјављени сте, молимо сачувајте све податке и пријавите се поново',
      onBackendDown: 'Backend сервис има прекид рада. Погледај %{details} за више информација'
    }
  },
  workflow: {
    workflow: {
      loading: 'Учитавање уноса уредничког тока рада',
      workflowHeading: 'Уреднички ток рада',
      newPost: 'Нова објава',
      description: '%{smart_count} унос чека преглед, %{readyCount} спреман за производњу. |||| %{smart_count} уноса чека преглед, %{readyCount} спремно за производњу. ',
      dateFormat: 'MMMM D'
    },
    workflowCard: {
      lastChange: '%{date} од стране %{author}',
      lastChangeNoAuthor: '%{date}',
      lastChangeNoDate: 'од стране %{author}',
      deleteChanges: 'Избриши измене',
      deleteNewEntry: 'Избриши нови унос',
      publishChanges: 'Објави измене',
      publishNewEntry: 'Објави нови унос'
    },
    workflowList: {
      onDeleteEntry: 'Да ли сте сигурни да желите да избришете овај унос?',
      onPublishingNotReadyEntry: 'Само ставке са статусом „Спремно" могу бити објављене. Молимо превуците картицу у колону „Спремно" да бисте омогућили објављивање.',
      onPublishEntry: 'Да ли сте сигурни да желите да објавите овај унос?',
      draftHeader: 'Нацрти',
      inReviewHeader: 'На прегледу',
      readyHeader: 'Спремно',
      currentEntries: '%{smart_count} унос |||| %{smart_count} уноса'
    }
  }
};
export default sr_Cyrl;